import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import placeholder from 'lib/placeholder';

const ToggleRepliesButton = ({
  commentId,
  isShowingReplies,
  onToggleReplies,
}) => (
  <Button
    aria-label="Ver respostas"
    iconRight={<Icon name={isShowingReplies ? 'arrow-up' : 'arrow-down'} />}
    size="size4"
    type="neutral-ghost"
    onClick={() => onToggleReplies(commentId)}
  >
    {isShowingReplies
      ? placeholder('actions.close')
      : placeholder('actions.seeReplies')}
  </Button>
);

ToggleRepliesButton.propTypes = {
  commentId: PropTypes.number.isRequired,
  isShowingReplies: PropTypes.bool.isRequired,
  onToggleReplies: PropTypes.func.isRequired,
};

export default ToggleRepliesButton;
